/* 
 * Export component file to be used on project
*/

import SuccessPlanAdded from './SuccessPlanAdded';
export default SuccessPlanAdded;
